<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <user-profile-update />
    </div>
  </div>
</template>

  <script>
  import UserProfileUpdate from '../Components/UserProfileUpdate.vue';

  export default {
    name: 'Organizations',
    components: {
        'user-profile-update': UserProfileUpdate,
    },
  };
  </script>

  <style scoped>

  </style>
